// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yUEA","index":"styles_index__2lG_J"};